<div class="container-fluid h-100">
    <div class="row h-100">
        <div class="col-sm-auto col-md"></div>
        <div class="col-sm col-md-auto h-100 text-center">
            <div class="alert alert-info mt-5">
                <div>
                    파일 다운로드 유효기간은 7일 입니다.
                </div>
                <ng-container *ngIf="fileExist === false">
                    <div class="mt-2">
                        유효기간이 지났거나 존재하지 않는 파일입니다.
                    </div>
                </ng-container>
            </div>
            <ng-container *ngIf="fileExist === true">
                <button type="button" class="btn btn-lg btn-info mt-5"
                    (click)="clickEtasFileDownload()">
                    다운로드
                </button>
            </ng-container>
        </div>
        <div class="col-sm-auto col-md"></div>
    </div>
</div>